import { matchPath } from 'react-router';
import { createSelector } from 'reselect';

import { INTERVENTION_PATHS_BY_TYPE } from 'constants/RoutesConstants';
import { getLocation } from 'modules/router/selectors';

/**
 *
 * @param {import("constants/RoutesConstants").FBPath[]} paths
 * @param {string} pathname
 */
const getMatchingPath = (paths, pathname) =>
  paths.reduce((acc, path) => {
    const matching = matchPath(path, pathname);
    if (!acc && matching) {
      return matching;
    }
    return acc;
  }, null);

export const getInterventionSubscription = createSelector(getLocation, location => {
  const [entityType, interventionId] = Object.entries(INTERVENTION_PATHS_BY_TYPE).reduce((acc, [type, paths]) => {
    const match = getMatchingPath(paths, location.pathname);
    if (match) {
      return [type, match.params.interventionId];
    }
    return acc;
  }, []);

  return {
    entityType,
    entityId: interventionId,
  };
});
